(function() {
  'use strict';
  var browser = document.querySelector('[data-product-browser]');
  if (!browser) return;

  var sectionId = browser.dataset.sectionId;
  var defaultCollection = browser.dataset.defaultCollection || 'bestseller';
  var grid = browser.querySelector('[data-product-grid]');
  var pillsContainer = browser.querySelector('[data-function-pills]');
  var titleEl = browser.querySelector('[data-browser-title]');
  var countEl = browser.querySelector('[data-browser-count]');
  var viewAllEl = browser.querySelector('[data-browser-view-all]');
  var currentTroop = null, currentFonction = null, abortController = null;
  var bundleData = null;
  try { var bd = document.getElementById('bundle-promo-data'); if (bd) bundleData = JSON.parse(bd.textContent); } catch(e) {}

  /* Confirmation strip elements */
  var confirmStrip = browser.querySelector('[data-troop-confirm-strip]');
  var confirmName = confirmStrip ? confirmStrip.querySelector('[data-confirm-name]') : null;
  var confirmClose = confirmStrip ? confirmStrip.querySelector('[data-confirm-close]') : null;

  function prefersReducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function showConfirmStrip(title) {
    if (!confirmStrip || !confirmName) return;
    confirmName.textContent = title;
    confirmStrip.classList.remove('hidden');
  }

  function hideConfirmStrip() {
    if (!confirmStrip) return;
    confirmStrip.classList.add('hidden');
  }

  /* Clear filter from confirmation strip X */
  if (confirmClose) {
    confirmClose.addEventListener('click', function() {
      currentTroop = null; currentFonction = null;
      hideConfirmStrip();
      loadCollection(defaultCollection, null);
      document.dispatchEvent(new CustomEvent('troop:clear'));
    });
  }

  document.addEventListener('troop:selected', function(e) {
    var handle = e.detail.handle;
    var title = e.detail.title;
    if (!handle) {
      currentTroop = null; currentFonction = null;
      hideConfirmStrip();
      loadCollection(defaultCollection, null);
      return;
    }
    currentTroop = handle; currentFonction = null;
    loadCollection(handle, title);
    showConfirmStrip(title || handle);

    /* Mobile: scroll to products after selection */
    if (window.innerWidth < 600) {
      setTimeout(function() {
        browser.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }, 150);
    }
  });

  var params = new URLSearchParams(window.location.search);
  var initialTroop = params.get('troop');
  var initialFonction = params.get('fonction');
  if (initialTroop) {
    currentTroop = initialTroop; currentFonction = initialFonction;
    loadCollection(initialTroop, null);
    showConfirmStrip(initialTroop);
  }

  async function loadCollection(collectionHandle, title) {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    showLoading();
    try {
      var url = '/collections/' + collectionHandle + '?section_id=' + sectionId;
      var response = await fetch(url, { signal: abortController.signal });
      if (!response.ok) throw new Error('Failed: ' + response.status);
      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-product-grid]');
      var newViewAll = doc.querySelector('[data-browser-view-all]');

      if (newGrid) {
        var cards = newGrid.querySelectorAll('.product-browser__card');
        var emptyMsg = newGrid.querySelector('.product-browser__empty');
        grid.innerHTML = '';
        if (cards.length > 0) { cards.forEach(function(c) { grid.appendChild(c.cloneNode(true)); }); }
        else if (emptyMsg) { grid.appendChild(emptyMsg.cloneNode(true)); }
      }
      if (titleEl && title) titleEl.textContent = title;
      injectBundlePromo(collectionHandle);
      var productCards = grid.querySelectorAll('.product-browser__card');
      if (countEl) countEl.textContent = productCards.length > 0 ? productCards.length + ' produits' : '';
      if (viewAllEl && newViewAll) { viewAllEl.innerHTML = newViewAll.innerHTML; viewAllEl.style.display = ''; }
      else if (viewAllEl) { viewAllEl.style.display = 'none'; }
      buildFunctionPills(productCards);
      if (currentFonction) applyFunctionFilter(currentFonction);
      hideLoading();
    } catch (error) {
      if (error.name !== 'AbortError') { console.error('Product browser error:', error); hideLoading(); }
    } finally { abortController = null; }
  }

  function buildFunctionPills(productCards) {
    var fonctionSet = {};
    productCards.forEach(function(card) {
      var vals = card.dataset.fonctionValues;
      if (!vals) return;
      vals.split(',').forEach(function(v) { var t = v.trim(); if (t) fonctionSet[t] = (fonctionSet[t] || 0) + 1; });
    });
    var names = Object.keys(fonctionSet).sort();
    if (names.length <= 1) { pillsContainer.classList.add('hidden'); return; }

    var html = '<button type="button" class="product-browser__fn-pill" aria-pressed="true" data-fonction="all">Tous</button>';
    names.forEach(function(name) {
      var pressed = currentFonction === name ? 'true' : 'false';
      html += '<button type="button" class="product-browser__fn-pill" aria-pressed="' + pressed + '" data-fonction="' + esc(name) + '">' + esc(name) + ' (' + fonctionSet[name] + ')</button>';
    });
    pillsContainer.innerHTML = html;
    pillsContainer.classList.remove('hidden');
    if (currentFonction) { var ap = pillsContainer.querySelector('[data-fonction="all"]'); if (ap) ap.setAttribute('aria-pressed', 'false'); }

    pillsContainer.querySelectorAll('[data-fonction]').forEach(function(pill) {
      pill.addEventListener('click', function() {
        var fn = pill.dataset.fonction;
        if (fn === 'all') { currentFonction = null; showAllProducts(); } else { currentFonction = fn; applyFunctionFilter(fn); }
        pillsContainer.querySelectorAll('[data-fonction]').forEach(function(p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        updateURL(); updateCount();
      });
    });
  }

  function applyFunctionFilter(name) {
    grid.querySelectorAll('.product-browser__card').forEach(function(card) {
      var vals = (card.dataset.fonctionValues || '').split(',').map(function(v) { return v.trim(); });
      card.classList.toggle('filtered-out', vals.indexOf(name) < 0);
    });
    var visible = grid.querySelectorAll('.product-browser__card:not(.filtered-out)');
    var em = grid.querySelector('[data-empty-msg]');
    if (visible.length === 0 && !em) {
      var d = document.createElement('div'); d.className = 'product-browser__empty'; d.textContent = 'Aucun produit pour cette fonction'; d.setAttribute('data-empty-msg', ''); grid.appendChild(d);
    } else if (visible.length > 0 && em) { em.remove(); }
  }

  function showAllProducts() {
    grid.querySelectorAll('.product-browser__card').forEach(function(c) { c.classList.remove('filtered-out'); });
    var em = grid.querySelector('[data-empty-msg]'); if (em) em.remove();
  }

  function updateCount() {
    if (!countEl) return;
    var v = grid.querySelectorAll('.product-browser__card:not(.filtered-out)');
    countEl.textContent = v.length > 0 ? v.length + ' produits' : '';
  }

  function updateURL() {
    var url = new URL(window.location);
    if (currentTroop) url.searchParams.set('troop', currentTroop);
    if (currentFonction) url.searchParams.set('fonction', currentFonction); else url.searchParams.delete('fonction');
    window.history.replaceState({}, '', url);
  }

  function showLoading() {
    grid.querySelectorAll('.product-browser__card, .product-browser__empty').forEach(function(c) { c.style.opacity = '0.3'; });
    var loader = document.createElement('div'); loader.className = 'product-browser__loading'; loader.setAttribute('data-browser-loading', '');
    loader.innerHTML = '<div class="product-browser__spinner"></div>'; grid.prepend(loader);
  }

  function hideLoading() {
    var l = grid.querySelector('[data-browser-loading]'); if (l) l.remove();
    grid.querySelectorAll('.product-browser__card').forEach(function(c) { c.style.opacity = ''; });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* Read hierarchy for branch→function mapping */
  var hierarchyData = {};
  try { var hEl = document.getElementById('military-hierarchy-data'); if (hEl) hierarchyData = JSON.parse(hEl.textContent); } catch(e) {}

  function injectBundlePromo(troopHandle) {
    /* Remove all existing promo cards */
    grid.querySelectorAll('[data-bundle-promo]').forEach(function(el) { el.remove(); });
    if (!bundleData || !troopHandle) return;
    var tmpl = document.getElementById('bundle-promo-template');
    if (!tmpl) return;

    /* Collect matching handles: direct match OR all child functions of a branch */
    var handles = [];
    if (bundleData[troopHandle]) {
      handles.push(troopHandle);
    }
    if (hierarchyData[troopHandle]) {
      hierarchyData[troopHandle].forEach(function(fn) {
        if (bundleData[fn] && handles.indexOf(fn) < 0) handles.push(fn);
      });
    }
    if (handles.length === 0) return;

    /* Inject one promo card per matching bundle (in reverse so first ends up on top) */
    for (var i = handles.length - 1; i >= 0; i--) {
      var bundle = bundleData[handles[i]];
      var clone = tmpl.content.cloneNode(true);
      var card = clone.querySelector('[data-bundle-promo]');
      var link = clone.querySelector('[data-bundle-link]');
      var img = clone.querySelector('[data-bundle-image]');
      var title = clone.querySelector('[data-bundle-title]');
      var badge = clone.querySelector('.bundle-promo-card__badge');
      if (link) link.href = bundle.url;
      if (img) { img.src = bundle.image; img.alt = bundle.title; }
      if (title) title.textContent = bundle.title;
      if (badge) badge.textContent = bundle.discount;
      if (card) card.style.display = '';
      grid.prepend(clone);
    }
  }
})();
